export default __webpack_public_path__ + "static/media/arg.1179bc59.svg";